import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/modules/core/services/http.service';
import { StateCategory } from '../store/models/user-state.model';
import { Observable, of } from 'rxjs';
import { MemoryCacheService } from './memory-cache.service';
import { tap } from 'rxjs/operators';

import { API_BASE_URL as apiBaseUrl } from '@app/core/constants/api-base-url';
import { UserContextService } from './user-context.service';

@Injectable({ providedIn: 'root' })
export class UserStateService {
  constructor(
    private http: HttpService,
    private memoryCacheService: MemoryCacheService,
    private userContext: UserContextService
  ) {}

  getUserState(category: StateCategory, key: string): Observable<any> {
    if (!key) {
      return null;
    }

    const { userProfileUId, organizationUId } = this.userContext.getContext();

    const cacheKey = `${organizationUId}:${userProfileUId}:${category}:${key}`;

    const cachedValue = this.memoryCacheService.getItem(cacheKey);

    if (cachedValue !== undefined) {
      return of(cachedValue);
    }

    const url = `${apiBaseUrl}/v1/data/UserState/state/${category}/?key=${key}`;

    return this.http.get<string>(url).pipe(
      tap(state => {
        this.memoryCacheService.setItem(cacheKey, state, 30);
      })
    );
  }

  setUserState(category: StateCategory, key: string, state: string): Observable<void> {
    if (!key) {
      return;
    }

    const url = `${apiBaseUrl}/v1/data/UserState/${category}/?key=${key}`;

    const { userProfileUId, organizationUId } = this.userContext.getContext();

    const cacheKey = `${organizationUId}:${userProfileUId}:${category}:${key}`;

    this.memoryCacheService.deleteItem(cacheKey);

    return this.http.post(url, { state });
  }

  clearUserState(category?: StateCategory, key?: string): Observable<void> {
    const params = {};
    if (!!category) {
      params["category"] = category;
    }
    if (!!key) {
      params["key"] = key;
    }
    const queryString = this.http.queryStringFromObject(params);

    const url = `${apiBaseUrl}/v1/data/UserState?${queryString}`;

    const cacheKey = `${category}:${key}`;
    this.memoryCacheService.deleteItem(cacheKey);

    return this.http.delete(url);
  }
}
